import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { colors } from '../theme/palette';

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		dialog: {
			width: 500,
			maxHeight: 400,
		},
		titleContainer: {
			backgroundColor: colors.navyAccent,
			padding: theme.spacing(2),
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			color: colors.pureWhite,
		},
		title: {
			color: colors.pureWhite,
			fontWeight: 600,
			fontSize: '1.25rem',
		},
		closeIcon: {
			color: colors.pureWhite,
		},
		content: {
			padding: theme.spacing(3),
			textAlign: 'center',
		},
		message: {
			color: colors.grayDark,
			lineHeight: 1.6,
			marginBottom: theme.spacing(2),
		},
		contactInfo: {
			color: colors.grayDark,
			fontWeight: 500,
			marginBottom: theme.spacing(1),
		},
		email: {
			color: colors.tealAccent,
			textDecoration: 'none',
			fontWeight: 600,
			'&:hover': {
				textDecoration: 'underline',
			},
		},
		phone: {
			color: colors.tealAccent,
			textDecoration: 'none',
			fontWeight: 600,
			'&:hover': {
				textDecoration: 'underline',
			},
		},
		dialogActions: {
			backgroundColor: colors.grayLight5,
			padding: theme.spacing(2),
			justifyContent: 'center',
		},
		okButton: {
			backgroundColor: colors.blueAccent,
			color: colors.pureWhite,
			'&:hover': {
				backgroundColor: colors.navyAccent,
			},
		},
	})
);

export type AccountLockedModalProps = {
	open: boolean;
	handleClose: () => void;
};

export const AccountLockedModal: React.FC<AccountLockedModalProps> = ({ open, handleClose }) => {
	const classes = useStyles();

	const handleEmailClick = () => {
		window.open('mailto:services@viiision.com', '_blank');
	};

	const handlePhoneClick = () => {
		window.open('tel:8338666896', '_blank');
	};

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			PaperProps={{ elevation: 0 }}
			disableEscapeKeyDown
			disableBackdropClick
		>
			<DialogTitle className={classes.titleContainer}>
				<Typography className={classes.title}>Account Deactivated</Typography>
				<IconButton className={classes.closeIcon} onClick={handleClose} edge="end">
					<CloseIcon fontSize="small" />
				</IconButton>
			</DialogTitle>
			<DialogContent className={classes.content}>
				<Typography className={classes.message} variant="body1">
					This account is currently deactivated.
					<br /> To reach Viiision customer service, please contact us at <br />
					<a href="mailto:services@viiision.com" className={classes.email} onClick={handleEmailClick}>
						services@viiision.com
					</a>
					<br />
					or by calling
					<br />
					<a href="tel:8338666896" className={classes.phone} onClick={handlePhoneClick}>
						833.866.6896
					</a>
				</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogActions}>
				<Button className={classes.okButton} variant="contained" onClick={handleClose} disableElevation>
					OK
				</Button>
			</DialogActions>
		</Dialog>
	);
};
